/**
 * The terminal table: a header strip on the page ground, rows that light up
 * under the pointer, and cells inset to line up with the panel header above.
 * A table inside a Panel wraps itself in TABLE_BLEED so the strip and the row
 * rules run to the panel edges, as in the mocks.
 */
// `relative` makes the scroller the containing block: an absolutely placed
// child (a screen-reader-only column label) would otherwise escape it and
// widen the whole page on a phone.
export const TABLE_BLEED = "relative -mx-4 -mb-4 overflow-x-auto";
export const TABLE_HEAD = "bg-background-base text-label-caps text-text-muted";
export const TABLE_ROW = "border-t border-border-subtle transition-colors duration-150 hover:bg-surface-hover";
export const CELL = "px-4 py-2";
